<template>
  <a
    ref="toggleDesc"
    href="javascript:;"
    class="toggle-desc"
    @click.stop="toggleDesc"
  >
    <template v-if="isShowDefault">
      <span class="toggle-desc-text">{{ text }}</span>
      <i key="arrows" :class="classname" />
    </template>
  </a>
</template>

<script>
  import { buriedSubmit } from 'common/js/common'
  export default {
    props: {
      isShowDefault: {
        type: Boolean,
        default: false
      },
      statId: String,
      statIdHide: String,
      descShow: Array,
      firstIdx: Number,
      secondIdx: Number,
    },
    data() {
      return {
        text: '',
        classname: '',
        show: false
      }
    },
    watch: {
      show: {
        handler(v) {
          this.text = v ? '收起' : '展开详情'
          this.classname = v ? 'iconfont icon-arrows_up' : 'iconfont icon-arrows_down'
        },
        immediate: true
      },
      descShow: {
        handler(v) {
          if (!v || !v.length) return
          if (isNaN(this.firstIdx) || isNaN(this.secondIdx)) return
          this.show = v[this.firstIdx][this.secondIdx]
        },
        immediate: true
      }
    },
    methods: {
      toggleDesc () {
        this.show = !this.show;
        this.$emit('toggle', this.$refs.toggleDesc);
        buriedSubmit(this.show ? this.statId : this.statIdHide)
      }
    }
  }
</script>

<style scoped>
  @import 'variable.css';
  .toggle-desc {
    position: relative;
    display: block;
    text-align: center;
    outline: none;
    font-size: 16px;
    .icon-arrows_down, .icon-arrows_up {
      margin-left: 4px;
      font-weight: bold;
      transform: translate(0, 2px);
      display: inline-block
    }
    .toggle-desc-text {
      font-size: 0.26rem;
    }
  }
</style>